import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
//import ReactMarkdown from "react-markdown";
//import { Link } from "react-router-dom";
import parse from "html-react-parser";
//import { useNavigate } from "react-router-dom";
//import { formatUrl } from "../../util/format-url";

export default function Content(props: any) {
  const location = useLocation();
  const propContent: any = useRef(null);
  const [tableOfContents, setTableOfContents] = useState([]);
  const [allH2s, setAllH2s] = useState([]);
  const [activeH2, setActiveH2] = useState("");
  const [allH3s, setAllH3s] = useState([]);
  const [activeH3, setActiveH3] = useState("");
  //let navigate = useNavigate();
  let { activatePageTitle, navList } = props;
  var navListCopy: any = [...navList];
  let activeMenuGroup: any = null;
  navListCopy.forEach((menu_group: any) => {
    var findItem: any = menu_group.items.filter((item: any) => {
      return item.name === activatePageTitle;
    });
    if (findItem.length > 0) {
      var filteredItem: any = findItem.filter((item: any) => {
        return item.name === activatePageTitle;
      });
      if (filteredItem[0] && filteredItem[0].name === activatePageTitle) {
        activeMenuGroup = menu_group;
      }
    } else {
      menu_group.items.forEach((item: any) => {
        if (item.subitems && item.subitems.length > 0) {
          var filteredSubitem: any = item.subitems.filter((subitem: any) => {
            return subitem.name === activatePageTitle;
          });
          if (
            filteredSubitem[0] &&
            filteredSubitem[0].name === activatePageTitle
          ) {
            activeMenuGroup = menu_group;
          }
        }
      });
    }
  });
  useEffect(() => {
    var temp_h2: string = "";
    var temp_h3: string = "";
    var temp_cont: any = {};
    Object.keys(propContent.current.parentElement.children).forEach(
      (ele: any) => {
        if (propContent.current.parentElement.children[ele].tagName === "H2") {
          temp_h2 = propContent.current.parentElement.children[ele].textContent;
        }
        if (propContent.current.parentElement.children[ele].tagName === "H3") {
          temp_h3 = propContent.current.parentElement.children[ele].textContent;
        }
        /* console.log(
          "ele",
          ele,
          propContent.current.parentElement.children[ele],
          "temp_h2",
          temp_h2,
          "temp_h3",
          temp_h3
        ); */
        if (temp_h2) {
          if (temp_cont[temp_h2]) {
            //temp_cont[temp_h2].push(temp_h3);
            if (
              temp_h3 &&
              !temp_cont[temp_h2].includes(temp_h3) &&
              !Object.values(temp_cont).some((val: any) =>
                val.includes(temp_h3)
              )
            ) {
              temp_cont[temp_h2] = [...temp_cont[temp_h2], temp_h3];
            }
          } else {
            temp_cont[temp_h2] = [];
            /*if (temp_h3) {
              temp_cont[temp_h2] = [...temp_cont[temp_h2], temp_h3];
            }*/
          }
        }
      }
    );
    setTableOfContents(temp_cont);
    /*console.log("temp_cont", temp_cont);
    Object.keys(temp_cont).forEach((tc: any) => {
      console.log("tc", tc, temp_cont[tc]);
    });*/
    let tempAllH2s: any =
      propContent.current.parentElement.getElementsByTagName("h2");
    //console.log("allH2s", allH2s);
    if (tempAllH2s) {
      var temp_h2s: any = [];
      if (Object.keys(tempAllH2s).length > 0) {
        //setAllH2s(tempAllH2s);
        Object.keys(tempAllH2s).forEach((h2: any) => {
          //console.log("h2", tempAllH2s[h2].textContent);
          if (tempAllH2s[h2].textContent && tempAllH2s[h2].textContent !== "") {
            temp_h2s = [...temp_h2s, tempAllH2s[h2]];
          }
        });
        //console.log("temp_h2s", temp_h2s);
        if (temp_h2s) {
          setAllH2s(temp_h2s);
        }
      }
    }
    let tempAllH3s: any =
      propContent.current.parentElement.getElementsByTagName("h3");
    if (tempAllH3s) {
      var temp_h3s: any = [];
      if (Object.keys(tempAllH3s).length > 0) {
        //setAllH3s(tempAllH3s);
        Object.keys(tempAllH3s).forEach((h3: any) => {
          //console.log("h3", tempAllH3s[h3].textContent);
          if (tempAllH3s[h3].textContent && tempAllH3s[h3].textContent !== "") {
            temp_h3s = [...temp_h3s, tempAllH3s[h3]];
          }
        });
        //console.log("temp_h3s", temp_h3s);
        if (temp_h3s) {
          setAllH3s(temp_h3s);
        }
      }
    }

    // Give time for page to fully load before before scrolling to hash
    // Fixes content not appearing at top of page
    setTimeout(() => {
      scrollToHash();
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //console.log("allH2s", allH2s);
    if (allH2s && !activeH2) {
      let counter: number = 0;
      Object.keys(allH2s).forEach((h2Ele: any) => {
        //console.log("h2Ele", allH2s[h2Ele].outerText);
        if (isInViewport(allH2s[h2Ele])) {
          //console.log("isInViewport", allH2s[h2Ele]["outerText"]);
          if (counter === 0) {
            setActiveH2(allH2s[h2Ele]["outerText"]);
            counter++;
          }
        }
      });
    }
  }, [allH2s, activeH2]);

  useEffect(() => {
    //console.log("allH3s", allH3s);
    if (allH3s && !activeH3) {
      let counter: number = 0;
      Object.keys(allH3s).forEach((h3Ele: any) => {
        //console.log("h3Ele", allH3s[h3Ele]["outerText"]);
        if (isInViewport(allH3s[h3Ele])) {
          //console.log("isInViewport", allH3s[h3Ele]["outerText"]);
          if (counter === 0) {
            setActiveH3(allH3s[h3Ele]["outerText"]);
            counter++;
          }
        }
      });
    }
  }, [allH3s, activeH3]);

  useEffect(() => {
    const handleScroll = (event: any) => {
      //console.log("window.scrollY", window.scrollY);
      //console.log("allH2s", allH2s);
      let countH2s: number = 0;
      Object.keys(allH2s).forEach((h2Ele: any) => {
        //console.log("h2Ele", allH2s[h2Ele]["offsetTop"]);
        if (
          isInViewport(allH2s[h2Ele]) &&
          allH2s[h2Ele]["textContent"] &&
          allH2s[h2Ele]["textContent"] !== ""
        ) {
          if (countH2s === 0) {
            setActiveH2(allH2s[h2Ele]["textContent"]);
            countH2s++;
          }
        }
      });
      let countH3s: number = 0;
      Object.keys(allH3s).forEach((h3Ele: any) => {
        //console.log("h3Ele", allH3s[h3Ele]["offsetTop"]);
        if (
          isInViewport(allH3s[h3Ele]) &&
          allH3s[h3Ele]["textContent"] &&
          allH3s[h3Ele]["textContent"] !== ""
        ) {
          /*console.log(
            "isInViewport",
            allH3s[h3Ele]["textContent"],
            allH3s[h3Ele]["offsetTop"]
          );*/
          if (countH3s === 0) {
            setActiveH3(allH3s[h3Ele]["textContent"]);
            //console.log("scroll h3: ", allH3s[h3Ele]["textContent"]);
            if (Object.keys(tableOfContents).length > 0) {
              Object.keys(tableOfContents).forEach((h2: any) => {
                //console.log("h2", h2);
                if (tableOfContents[h2]) {
                  var temp_h2: any = tableOfContents[h2];
                  //console.log("temp_h2", temp_h2);
                  if (temp_h2.includes(allH3s[h3Ele]["textContent"])) {
                    //console.log("temp_h2 match", temp_h2);
                    Object.keys(tableOfContents[h2]).forEach((h3: any) => {
                      //console.log("h3", tableOfContents[h2][h3]);
                      if (tableOfContents[h2][h3]) {
                        if (
                          allH3s[h3Ele]["textContent"] ===
                          tableOfContents[h2][h3]
                        ) {
                          //console.log("active h3 parent h2: ", h2);
                          setActiveH2(h2);
                        }
                      }
                    });
                  }
                }
              });
            }
            countH3s++;
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const scrollToHash = () => {
    const hash = location.hash;
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  const handleContentItemClick = (group: any, item: string) => {
    //console.log("handleContentItemClick", group, item, allH2s);
    let tempAllH2s: any = allH2s;
    //console.log("tempAllH2s", tempAllH2s);
    let h2Element: any = null;
    if (tempAllH2s) {
      Object.keys(tempAllH2s).forEach((h2Ele: any) => {
        //console.log("h2Ele", allH2s[h2Ele].outerText);
        if (tempAllH2s[h2Ele].outerText === item) {
          /*console.log(
            "tempAllH2s[h2Ele].offsetTop",
            tempAllH2s[h2Ele].offsetTop
          );*/
          h2Element = tempAllH2s[h2Ele];
        }
      });
    }
    //console.log("offsetTop", offsetTop, "h2Element", h2Element);
    if (h2Element) {
      h2Element.scrollIntoView({ behavior: "smooth", block: "start" });
      //setActiveH2(item);
    }
  };

  const handleContentSubItemClick = (group: any, h2: string, h3: string) => {
    //console.log("handleContentSubItemClick", group, h2, h3);
    let tempAllH3s: any = allH3s;
    let h3Element: any = null;
    if (tempAllH3s) {
      Object.keys(tempAllH3s).forEach((h3Ele: any) => {
        if (tempAllH3s[h3Ele].outerText === h3) {
          h3Element = tempAllH3s[h3Ele];
        }
      });
    }
    if (h3Element) {
      h3Element.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveH3(h3);
    }
  };

  return (
    <>
      {props.content ? (
        <>
          <style>
            {`
              .content h2 {
                scroll-margin-top: 64px;
              }
              .content h3 {
                scroll-margin-top: 64px;
              }
            `}
          </style>
          <div className="content">
            <div className="content-inner">
              <div
                className="content-data"
                onClick={(e: any) => props.handleContentClick(e)}
              >
                <h1>{props.name}</h1>
                {/* <ReactMarkdown children={props.content} /> */}
                <div id="prop-content" ref={propContent}></div>
                {parse(props.content)}
              </div>
            </div>
          </div>
          {tableOfContents && Object.keys(tableOfContents).length > 0 && (
            <div className="table-of-content">
              <div className="table-of-content-inner">
                <div className="table-of-content-title">Table of contents</div>
                {Object.keys(tableOfContents).map((h2: any) => (
                  <div className="table-of-content-section">
                    <div
                      className={`table-of-content-item ${
                        h2 === activeH2 ? "active" : ""
                      }`}
                      key={`table-of-content-item-${h2}`}
                      onClick={(e: any) =>
                        // handleLinkClick(activeMenuGroup, item, "menu-item")
                        handleContentItemClick(activeMenuGroup, h2)
                      }
                    >
                      {h2}
                    </div>
                    {tableOfContents[h2] &&
                      Object.keys(tableOfContents[h2]).length > 0 &&
                      Object.keys(tableOfContents[h2]).map((h3: any) => (
                        <div
                          className={`table-of-content-subitem ${
                            h2 === activeH2 &&
                            tableOfContents[h2][h3] === activeH3
                              ? "active"
                              : ""
                          }`}
                          key={`table-of-content-subitem-${h3}`}
                          onClick={(e: any) =>
                            handleContentSubItemClick(
                              activeMenuGroup,
                              h2,
                              tableOfContents[h2][h3]
                            )
                          }
                        >
                          {tableOfContents[h2][h3]}
                        </div>
                      ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="no-content-found">No Content found</div>
      )}
    </>
  );
}

function isInViewport(element: any) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
